import React from 'react';

import { useDispatch, useSelector } from 'react-redux';
import CloseIcon from '../../assets/icons/CloseIcon';
import TelegramBtnIcon from '../../assets/icons/TelegramBtnIcon';
import { setUserData } from '../../store/slices/integrationSlice';
import Button from '../../ui/Button/Button';
import TextArea from '../../ui/TextArea/TextArea';
import Title from '../../ui/Title/Title';
import styles from './ModalSendUserMessage.module.scss';
import { postUserMessage } from '../../utils/api/actions/integrations/tgBot';

export default function ModalSendUserMessage() {
	const dispatch = useDispatch();

	const { userData, activeBot } = useSelector((state) => state.integration);

	const [visible, setVisible] = React.useState(false);
	const [message, setMessage] = React.useState('');
	const [visibleSuccessMessage, setVisibleSuccessMessage] =
		React.useState(false);

	React.useEffect(() => {
		if (userData) setVisible(true);
		return () => {
			setVisible(false);
		};
	}, [userData]);

	const handlerClose = () => {
		dispatch(setUserData(null));
		setVisible(false);
	};

	const handlerMessageText = (e) => setMessage(e.target.value);

	const observeSendMessage = () => {
		setTimeout(() => {
			setVisible(false);
			setVisibleSuccessMessage(false);
		}, 3000);
	};

	const handlerSendUserMessage = () => {
		let dataMessage = {
			id: activeBot.activeBot.id,
			telegramBotUserId: userData.id,
			message,
		};

		dispatch(postUserMessage(dataMessage));
		setMessage('');
		setVisibleSuccessMessage(true);
		observeSendMessage();
	};

	return (
		<div className={visible ? styles.container : styles.hide}>
			<div className={styles.closeContainer}></div>
			<div className={styles.layout}>
				<Button
					leftIcon={<CloseIcon />}
					onClick={handlerClose}
					className={styles.close}
				/>
				<div className={styles.header}>
					<Title
						title={`Отправить сообщение ${userData?.userName}`}
						className={styles.title}
					/>
				</div>
				<div className={styles.body}>
					<TextArea
						classNameTextArea={styles.messageContainer}
						rows='7'
						placeholder='Сообщение'
						value={message}
						onChange={handlerMessageText}
					/>
					<div className={styles.footer}>
						<Button
							leftIcon={<TelegramBtnIcon />}
							onClick={handlerSendUserMessage}
							className={styles.sendButton}
							titleClassName={styles.titleSendButton}
							title='Отправить'
						/>
						{visibleSuccessMessage && (
							<label className={styles.successMessage}>
								{`Сообщение отправлено ${userData?.firstName}`}
							</label>
						)}
					</div>
				</div>
			</div>
		</div>
	);
}
